export const environment = {
  production: false,
  envName: 'test',
  auth: {
    domain: 'cooprogetti-strumenti.eu.auth0.com',
    clientId: '2174UH3g0dRGZA17jiE8TAY6pMXvjK4n',
    audience: 'https://cooprogetti-be.map-hosting.it',
    redirectUri: `${window.location.origin}/callback`,
    roleClaim: "https://cooprogetti.map-hosting.it/roles",
  },
  backend: {
    baseUrl: 'https://refhub-be.map-hosting.it/api/v1', // TODO: sostituisci con la URL reale del backend di test
  },
  firebase: {
    apiKey: 'AIzaSyCp-IjLKD8NNqSAXVyjuCqsbpvYRO6TSCs',
    authDomain: 'cooprogetti-refhub.firebaseapp.com',
    projectId: 'cooprogetti-refhub',
    storageBucket: 'cooprogetti-refhub.firebasestorage.app',
    messagingSenderId: '718449376336',
    appId: '1:718449376336:web:abe7f38aa1fe803fd1a555',
    measurementId: 'G-BRQMLLPFBC',
    user: 'frontend-usr',
    password: 'fhTLyt-4XSV6q9skFU3r265Mgfudv_7N8Pgcubi9AisJLEPj',
    dbName: 'refhub-standard',
    collectionReferenze: 'referenze-test',
  },
};
